export  default {
    icon: "el-icon-document",
    title: "滚动公告",
    name: "news",
    timestamp: "1665385357481002",
    setUp: {
        tabVal: 0
    },
    txtStyle: {
        title: "文本位置",
        name: "txtStyle",
        type: 0,
        list: [
            {
                val: "居左",
                icon: "icondoc_left",
                style: "left"
            },
            {
                val: "居中",
                icon: "icondoc_center",
                style: "center"
            },
            {
                val: "居右",
                icon: "icondoc_right",
                style: "right"
            }
        ]
    },
    bgColor: {
        title: "背景颜色",
        default: [
            {
                item: "#fff"
            }
        ],
        color: [
            {
                item: "#fff"
            }
        ]
    },
    txtColor: {
        title: "文字颜色",
        default: [
            {
                item: "#333"
            }
        ],
        color: [
            {
                item: "#333"
            }
        ]
    },
    listConfig: {
        title: "最多可添加10个版块；鼠标拖拽左侧圆点可调整版块顺序",
        max: 10,
        list: [
            {
                child: [
                    {
                        title: "标题",
                        val: "本商城为测试站，请勿真实下单～",
                        max: 30,
                        pla: "选填，不超过30个字",
                        empty: true
                    },
                    {
                        title: "链接",
                        val: "/pages/index/index",
                        max: 200,
                        pla: "请输入连接"
                    }
                ]
            },
            {
                child: [
                    {
                        title: "标题",
                        val: "本商城为测试站，请勿真实下单～",
                        max: 30,
                        pla: "选填，不超过30个字",
                        empty: true
                    },
                    {
                        title: "链接",
                        val: "/pages/index/index",
                        max: 200,
                        pla: "请输入连接"
                    }
                ]
            }
        ],
        tabCur: 0
    },
    bgStyle: {
        title: "背景样式",
        name: "bgStyle",
        type: 1,
        list: [
            {
                val: "直角",
                icon: "el-icon-edit-outline"
            },
            {
                val: "圆角",
                icon: "el-icon-c-scale-to-original"
            }
        ]
    },
    prConfig: {
        title: "背景边距",
        val: 10,
        min: 0
    },
    mbConfig: {
        title: "页面间距",
        val: 10,
        min: 0
    },
    logoConfig: {
        header: "图标设置",
        title: "最多可添加1张图片，建议宽度130 * 36px",
        url: "SERVER_API" + "/images/decoration/noticeicon.png"
    },
    id: "id1665385357481002"
}